'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** @jsx dom */


var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _loadScript = require('load-script');

var _loadScript2 = _interopRequireDefault(_loadScript);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadWidget = function loadWidget(el) {
	var widgetEl = el.querySelector('.trustpilot-widget');

	if (widgetEl && window.Trustpilot) {
		window.Trustpilot.loadFromElement(widgetEl);
	}
};

var afterMount = function afterMount(comp, el) {
	(0, _loadScript2.default)('https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', function (err, script) {
		script.remove();
		loadWidget(el);
	});
};

var afterRender = function afterRender(_ref, el) {
	var props = _ref.props;
	return loadWidget(el);
};

var render = function render(_ref2) {
	var props = _ref2.props;

	var key = '' + props.locale + props.templateId + props.businessUnitId + props.height + props.width + props.theme + props.stars;
	var attributes = {
		'data-locale': props.locale,
		'data-template-id': props.templateId,
		'data-businessunit-id': props.businessUnitId,
		'data-style-height': props.height,
		'data-style-width': props.width,
		'data-theme': props.theme,
		'data-stars': props.stars
	};

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-Trustpilot', props.class] },
		(0, _magicVirtualElement2.default)(
			'div',
			_extends({ key: key, 'class': 'trustpilot-widget' }, attributes),
			(0, _magicVirtualElement2.default)(
				'a',
				{ href: props.reviewLink, target: '_blank' },
				'Trustpilot'
			)
		)
	), props);
};

exports.default = { afterRender: afterRender, afterMount: afterMount, render: render };